import { ShoppingBag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useFarmCart } from '@/context/FarmCartContext';
import { cn } from '@/lib/utils';

interface CartIconButtonProps {
  showText?: boolean;
  className?: string;
}

/**
 * Cart icon button for use in header navigation.
 * Shows item count badge and opens cart sheet.
 */
export function CartIconButton({ showText = false, className }: CartIconButtonProps) {
  const { itemCount, openCart } = useFarmCart();
    
  if(itemCount === 0) {
    return null;
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn(
        "relative gap-2 min-w-[44px] min-h-[44px] px-2",
        className
      )}
      onClick={openCart}
      aria-label={`Varukorg med ${itemCount} varor`}
    >
      <div className="relative">
        <ShoppingBag className="h-5 w-5" />
        {itemCount > 0 && (
          <span className="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full bg-primary text-[10px] font-semibold text-primary-foreground">
            {itemCount > 9 ? '9+' : itemCount}
          </span>
        )}
      </div>
      
      {showText && (
        <span className="hidden sm:inline text-sm font-medium">
          Varukorg
          {itemCount > 0 && <span className="text-muted-foreground ml-1">({itemCount})</span>}
        </span>
      )}
    </Button>
  );
}
